import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import GatewayTester from "@/components/GatewayTester";
import OcrTester from "@/components/OcrTester";
import AuditTable from "@/components/AuditTable";
import PiiAccessReport from "@/components/security/PiiAccessReport";
import AuditTimeline from "@/components/security/AuditTimeline";
import PosturePanel from "@/components/security/PosturePanel";

export default function SecurityConsolePage() {
  const [auditRefresh, setAuditRefresh] = useState(0);
  const bumpAudit = () => setAuditRefresh((k) => k + 1);

  return (
    <div className="space-y-5 fade-in" data-testid="security-console-page">
      <p className="text-[13px] text-muted-foreground -mt-2">
        AI Gateway · PII Masking Proxy · Access Reporting · Regulatory Posture — all LLM traffic is tokenized and audited.
      </p>
      <Tabs defaultValue="testers">
        <TabsList className="rounded-none bg-white border border-border h-10 p-0">
          {[["testers", "Gateway & OCR"], ["pii", "PII Access Report"], ["timeline", "Audit Timeline"], ["posture", "Compliance Posture"]].map(([v, l]) => (
            <TabsTrigger key={v} value={v} data-testid={`security-tab-${v}`}
              className="rounded-none h-full px-5 text-[12px] uppercase tracking-wider data-[state=active]:bg-[var(--brand-primary)] data-[state=active]:text-white">
              {l}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="testers" className="mt-4 space-y-6">
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 items-start">
            <GatewayTester onActivity={bumpAudit} />
            <OcrTester onActivity={bumpAudit} />
          </div>
          <AuditTable refreshKey={auditRefresh} />
        </TabsContent>
        <TabsContent value="pii" className="mt-4"><PiiAccessReport /></TabsContent>
        <TabsContent value="timeline" className="mt-4"><AuditTimeline /></TabsContent>
        <TabsContent value="posture" className="mt-4"><PosturePanel /></TabsContent>
      </Tabs>
    </div>
  );
}
